var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_93_2",
    "data-name": "Componente 93 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_321",
    "data-name": "Rect\\xE1ngulo 321",
    width: 26,
    height: 26,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chevron_right_FILL0_wght300_GRAD0_opsz40",
    d: "M356.819-688.487l-6.408-6.417a.85.85,0,0,1-.272-.648.894.894,0,0,1,.287-.653.907.907,0,0,1,.663-.282.907.907,0,0,1,.663.282l6.906,6.906a1.2,1.2,0,0,1,.266.379,1.1,1.1,0,0,1,.083.433,1.111,1.111,0,0,1-.083.428,1.186,1.186,0,0,1-.266.384l-6.921,6.921a.881.881,0,0,1-.648.267.908.908,0,0,1-.662-.282.907.907,0,0,1-.282-.663.907.907,0,0,1,.282-.663Z",
    transform: "translate(-675.486 -341.139) rotate(90)",
    fill: "#00bdd9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.57a2b379fe0f55fb9105ec3585f06da2.svg";
export { ForwardRef as ReactComponent };